<div [formGroup]="bookingService.internalCommentForm" class="main-container">
    <textarea pInputTextarea formControlName="body" class="text-area"></textarea>
    <p-button label="Save" (onClick)="updateComment()"></p-button>
</div>